<template>

  <ancestryline-modal title="forms.protocol.title"  id="create-quick-protocol" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-text v-model="form.name" label="forms.protocol.name" class="p-col-12 p-md-6 p-lg-6" />
      <coff-input-text v-model="form.familyName" label="forms.protocol.family-name" class="p-col-12 p-md-6 p-lg-6" />
      <coff-input-auto-complete v-model="form.mainClient" label="forms.protocol.main-client" class="p-col-11 p-md-5 p-lg-5" :itens="clients" field="name" :func-suggestions="searchClient" :error="validation.mainClient"/>
      <a class="cursor-pointer p-col-1 p-md-1 p-lg-1" @click.prevent="modalClientForm" style="margin-top: 30px;"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>
      <coff-input-radio v-model="form.haveTax" @update="forceUpdateField('haveTax', $event)" :options="options" label="forms.protocol.have-tax" class="p-col-12 p-md-6 p-lg-6" :error="validation.haveTax"/>
      <coff-input-radio v-model="form.budget" @update="forceUpdateField('budget', $event)" :options="options" label="forms.protocol.budget" class="p-col-12 p-md-6 p-lg-6" :error="validation.budget"/>
    </card>

    <card :header="$t('forms.protocol.card-information')" class="p-col-12" >
      <div class="p-col-12">
        <span>{{$t('forms.protocol.type-service')}}</span>
        <div class="p-d-flex p-col line-content line-of-service p-mb-2 p-mt-2 main-service">
          <div class="text-vertical-center">
            {{quickProtocol.mainService.name}}
          </div>
        </div>
      </div>

      <div class="p-col-12">
        <span>{{$t('forms.quick-protocol.type-services')}}</span>
      </div>

      <div class="p-col-12">
        <div v-for="(service, index) in quickProtocol.typeServices" :key="index">
          <div class="p-d-flex p-col-12 line-content line-of-service p-mb-2">
            <div class="text-vertical-center">
              {{service.name}}
            </div>
          </div>
        </div>
      </div>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('btn.save')" @click="save" class="p-ml-2 p-button-success"/>
      </div>
    </template>

  </ancestryline-modal>

</template>

<script>
import DialogService from "@/business/ModalBusiness";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ClientBusiness from "@/business/ClientBusiness";
import ValidationUtils from "@/utils/ValidationUtils";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import ModalClientForm from "@/viewer/client/ModalClientForm";

export default {
  name: "ModalCreateQuickProtocol",

  props: {
    quickProtocol: {type: Object, default: ()=>{return{}}}
  },

  data(){
    return {
      form: {},
      clients: [],
      validation: {
        mainClient: false,
        haveTax: false,
        budget: false,
      },
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
    }
  },

  async mounted() {
    this.clients =  await ClientBusiness.getAll();
  },

  methods: {

    close(){
      DialogService.closeModal();
    },

    async searchClient(name){
      return await ClientBusiness.search(name);
    },

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        this.normalizeForm();
        const response = await ProtocolBusiness.saveQuickProtocol(this.form).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          ToastMessageBusiness.showSuccess();
          DialogService.closeModal(response);
        }
      }
    },

    forceUpdateField(field, value){
      this.$set(this.form, field, value);
    },

    normalizeForm(){
      this.form.stage = {id: '598d1c42-3406-4eea-abf5-a8474aed198c'}
      this.form.typeService = this.quickProtocol.mainService;
      this.form.typeServices = this.quickProtocol.typeServices;
    },

    async modalClientForm(){
      const client = await DialogService.openModal(ModalClientForm, {}, 1000);
      if(client){
        this.$set(this.form, 'mainClient', client);
      }
    }

  }

}
</script>

<style scoped>

.main-service {
  border-left: 5px solid #358ccb;
}

span {
  font-size: medium;
}

</style>